// Handles keyboard input
// Nothing complicated, just tracks which keys are down

export class InputManager {
  private keysDown: Set<string>;
  private keysPressed: Set<string>; // for one-shot actions
  private keysReleased: Set<string>;

  constructor() {
    this.keysDown = new Set();
    this.keysPressed = new Set();
    this.keysReleased = new Set();

    // Bind event handlers
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
    window.addEventListener('keyup', this.handleKeyUp.bind(this));
  }

  private handleKeyDown(e: KeyboardEvent): void {
    // Prevent default for game keys so we don't scroll the page etc
    const gameKeys = [
      'ArrowUp',
      'ArrowDown',
      'ArrowLeft',
      'ArrowRight',
      'Space',
      'KeyP',
      'KeyB',
    ];
    if (gameKeys.includes(e.code)) {
      e.preventDefault();
    }

    if (!this.keysDown.has(e.code)) {
      this.keysPressed.add(e.code);
    }
    this.keysDown.add(e.code);
  }

  private handleKeyUp(e: KeyboardEvent): void {
    this.keysDown.delete(e.code);
    this.keysReleased.add(e.code);
  }

  // Check if key is currently held down
  isKeyDown(key: string): boolean {
    return this.keysDown.has(key);
  }

  // Check if key was just pressed this frame
  wasKeyPressed(key: string): boolean {
    return this.keysPressed.has(key);
  }

  // Check if key was just released this frame
  wasKeyReleased(key: string): boolean {
    return this.keysReleased.has(key);
  }

  // Call at end of each frame to clear one-shot states
  update(): void {
    this.keysPressed.clear();
    this.keysReleased.clear();
  }
}
